import React, { PureComponent, ReactNode } from 'react';

import { gridSize } from '@atlaskit/theme';

const EDIT_TOOLBAR_HEIGHT = gridSize() * 5 + 1; // 40px + 1 px border-top
const BOTTOM_MARGIN_PX_VIEW = gridSize() * 4;
const BOTTOM_MARGIN_PX_EDIT = BOTTOM_MARGIN_PX_VIEW + EDIT_TOOLBAR_HEIGHT;

type Props = {
  children: (props: { height: string }) => ReactNode;
  isEditing: boolean;
};

type State = {
  height: string | null | undefined;
  prevPropsIsEditing: boolean;
  wrapper: HTMLDivElement | null | undefined;
};

class FileContentsHeightProvider extends PureComponent<Props, State> {
  static calculateHeight = (opts: {
    isEditing: boolean;
    wrapper: HTMLDivElement | null | undefined;
  }) => {
    const { isEditing, wrapper } = opts;

    const distanceFromBottomPx = isEditing
      ? BOTTOM_MARGIN_PX_EDIT
      : BOTTOM_MARGIN_PX_VIEW;

    if (wrapper) {
      const { top } = wrapper.getBoundingClientRect();
      return `calc(100vh - ${top + distanceFromBottomPx}px)`;
    }

    return null;
  };

  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    isEditing: false,
  };

  state: State = {
    height: null,
    prevPropsIsEditing: this.props.isEditing,
    wrapper: null,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.isEditing !== state.prevPropsIsEditing) {
      return {
        height: FileContentsHeightProvider.calculateHeight({
          isEditing: props.isEditing,
          wrapper: state.wrapper,
        }),
        prevPropsIsEditing: props.isEditing,
      };
    }
    return null;
  }

  handleRef = (wrapper: HTMLDivElement | null | undefined) => {
    this.setState({
      height: FileContentsHeightProvider.calculateHeight({
        isEditing: this.props.isEditing,
        wrapper,
      }),
      wrapper,
    });
  };

  render() {
    const { height } = this.state;
    return (
      <div ref={this.handleRef}>
        {height ? this.props.children({ height }) : null}
      </div>
    );
  }
}

export { FileContentsHeightProvider };
